import styled from "styled-components"

const Wrapper = styled.div`
  max-width: 900px;
  margin: auto;
`

export default Wrapper
